import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';

type AppRedirectSearch = {
  noRedirect?: string;
  path?: string;
};

export const Route = createFileRoute('/app')({
  validateSearch: (search: Record<string, unknown>): AppRedirectSearch => ({
    noRedirect: typeof search.noRedirect === 'string' ? search.noRedirect : undefined,
    path: typeof search.path === 'string' ? search.path : undefined,
  }),
  head: () => ({
    meta: [{ title: 'Open the nsave app' }, { name: 'robots', content: 'noindex' }],
  }),
  component: AppRedirectPage,
});

function AppRedirectPage() {
  const { noRedirect, path } = Route.useSearch();

  useEffect(() => {
    if (!noRedirect) window.location.assign(`nsave://${path ?? ''}`);
  }, [noRedirect, path]);

  useEffect(() => {
    const reactNativeWindow = window as typeof window & {
      ReactNativeWebView?: { postMessage: (message: string) => void };
    };
    reactNativeWindow.ReactNativeWebView?.postMessage('done');
  }, []);

  if (noRedirect) return null;

  return (
    <main className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mx-auto h-8 w-8 animate-spin rounded-full border-b-2 border-[#D60707]" />
        <p className="mt-4 text-grey-600">Redirecting to the app...</p>
      </div>
    </main>
  );
}
